import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VueAxios from 'vue-axios';
import normalize from 'json-api-normalizer';
import Api from '../../services/api';

Vue.use(VueAxios, axios);

const vacancyStore = {
  namespaced: true,
  state: {
    vacancies: [],
    vacancy: [],
    form_vacancy: {},
    totalRecords: 1,
    wordSearch: '',
    citySearch: '',
    levelSearch: '',
    contractingSearch: '',
    fitCandidateSearch: '',
    currentPageV: 1,
    vacLoading: false,
  },
  mutations: {
    SET_VACANCIES(state, vacancies) {
      state.vacancies = vacancies;
    },
    SET_VACANCY(state, vacancy) {
      state.vacancy = vacancy;
    },
    SET_SHOW_VACANCY(state, value) {
      state.showVacancy = value;
    },
    SET_FORM_VACANCY(state, form_vacancy) {
      state.form_vacancy = form_vacancy;
    },
    LOADING(state, loading) {
      state.vacLoading = loading;
    },
    SET_TTRECORDS(state, records) {
      state.totalRecords = records;
    },
    SET_SEARCH(state, word) {
      state.wordSearch = word;
    },
    SET_CITY(state, cityId) {
      state.citySearch = cityId;
    },
    SET_LEVEL(state, level) {
      state.levelSearch = level;
    },
    SET_CONTRACT(state, contracting) {
      state.contractingSearch = contracting;
    },
    SET_CANDIDATE(state, fitCandidate) {
      state.fitCandidateSearch = fitCandidate;
    },
    SET_PAGE(state, page) {
      state.currentPageV = page;
    },
  },
  actions: {
    /**
     * New structure request vacancy. (Used form create vacancy.)
     */
    loadFormVacancy({ commit, dispatch }, id) {
      commit('LOADING', true);
      Api().get(`/vacancies/${id}`)
        .then((response) => {
          const vacancy = normalize(response.data);
          commit('SET_FORM_VACANCY', vacancy);
        }).catch((error) => {
          dispatch('ResponsesStore/clearErrors', 'companyConfigStore', { root: true });
          dispatch('ResponsesStore/setErrors', { context: 'companyConfigStore', ...error.response }, { root: true });
        })
        .finally(() => {
          commit('LOADING', false);
        });
    },
    createVacancy({ commit, dispatch }, formData) {
      commit('LOADING', true);
      return new Promise((resolve, reject) => {
        Api().post('/vacancies', formData)
          .then((response) => {
            if (response.status === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error.response);
            dispatch('ResponsesStore/clearErrors', 'companyConfigStore', { root: true });
            dispatch('ResponsesStore/setErrors', { context: 'companyConfigStore', ...error.response }, { root: true });
          })
          .finally(() => {
            commit('LOADING', false);
          });
      });
    },
    editVacancy({ commit, dispatch }, { id, formData }) {
      commit('LOADING', true);
      return new Promise((resolve, reject) => {
        Api().put(`/vacancies/${id}`, formData)
          .then((response) => {
            if (response.status === 200) {
              this.dispatch('VacancyStore/loadFormVacancy', id);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
            dispatch('ResponsesStore/clearErrors', 'companyConfigStore', { root: true });
            dispatch('ResponsesStore/setErrors', { context: 'companyConfigStore', ...error.response }, { root: true });
          })
          .finally(() => {
            commit('LOADING', false);
          });
      });
    },
    createVacancyDraft({ commit, dispatch }, formData) {
      commit('LOADING', true);
      return new Promise((resolve, reject) => {
        Api().post('/vacancies/create_draft', formData)
          .then((response) => {
            let location = window.location.pathname.split('/');
            location.pop();
            location.push(response.data.data.attributes.slug);
            location = location.join('/');
            if (response.status === 200) {
              resolve(response);
              window.location.replace(`${window.location.origin}${location}/editar#vacancy-details`);
            }
          })
          .catch((error) => {
            reject(error.response);
            dispatch('ResponsesStore/clearErrors', 'companyConfigStore', { root: true });
            dispatch('ResponsesStore/setErrors', { context: 'companyConfigStore', ...error.response }, { root: true });
            commit('LOADING', false);
          });
      });
    },
    editVacancyDraft({ commit, dispatch }, { id, formData }) {
      commit('LOADING', true);
      return new Promise((resolve, reject) => {
        Api().put(`/vacancies/${id}/update_draft`, formData)
          .then((response) => {
            if (response.status === 200) {
              resolve(response);
              this.dispatch('VacancyStore/loadFormVacancy', id);
            }
          })
          .catch((error) => {
            reject(error.response);
            dispatch('ResponsesStore/clearErrors', 'companyConfigStore', { root: true });
            dispatch('ResponsesStore/setErrors', { context: 'companyConfigStore', ...error.response }, { root: true });
            commit('LOADING', false);
          });
      });
    },
    /**
     * Old structure request vacancy. (Used external pages)
     */
    loadVacancies({ commit }, search) {
      commit('LOADING', true);

      let word = '';
      let cityId = '';
      let level = '';
      let contracting = '';
      let fitCandidate = 'open_to_candidates';
      let currentPage = 1;
      const searchParams = [];

      if (search !== undefined) {
        if (search.word !== undefined) word = search.word;
        if (search.page !== undefined) currentPage = search.page;
        if (search.cityId !== undefined) cityId = search.cityId;
        if (search.level !== undefined) level = search.level;
        if (search.contracting !== undefined) contracting = search.contracting;
        if (search.fitCandidate !== undefined) fitCandidate = search.fitCandidate;
      }

      if (search !== undefined && search.from !== undefined) {
        searchParams.push(`search[q]=${word}`);
        searchParams.push(`search[city_ids][]=${cityId}`);
        searchParams.push(`search[level_of_interest_ids]=${level}`);
        searchParams.push(`search[contracting_regimes]=${contracting}`);
        searchParams.push(`search[candidate_filter]=${fitCandidate}`);
      }

      if (window.location.search !== undefined) {
        searchParams.push(window.location.search.substr(1));
      }

      searchParams.push(`page=${currentPage}`);

      commit('SET_SEARCH', word);
      commit('SET_CITY', cityId);
      commit('SET_LEVEL', level);
      commit('SET_CONTRACT', contracting);
      commit('SET_CANDIDATE', fitCandidate);
      commit('SET_PAGE', currentPage);

      axios
        .get(`${window.location.origin}/api_v/v1/vagas.json?${searchParams.join('&')}`)
        .then(async (result) => (
          commit('SET_VACANCIES', normalize(result.data.vacancies)),
          commit('SET_TTRECORDS', result.data.pagy.count)
        ))
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => commit('LOADING', false));
    },
    loadVacancy({ commit }) {
      commit('LOADING', true);

      axios
        .get(`${window.location.origin}/api_v/v1/vagas/${window.location.pathname.split('/', 6).pop()}.json`)
        .then(async (vacancy) => {
          commit('SET_VACANCY', normalize(vacancy.data));
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => commit('LOADING', false));
    },
  },
  getters: {
    isVacLoading: (state) => (state.vacLoading),
    getVacancies: (state) => (state.vacancies),
    getVacancy: (state) => (state.vacancy),
    getFormVacancy: (state) => (state.form_vacancy),
    getTotalRecords: (state) => (state.totalRecords),
    getWordSearch: (state) => (state.wordSearch),
    getCitySearch: (state) => (state.citySearch),
    getLevelSearch: (state) => (state.levelSearch),
    getContractingSearch: (state) => (state.contractingSearch),
    getFitCandidateSearch: (state) => (state.fitCandidateSearch),
    getCurrentPageV: (state) => (state.currentPageV),
  },
};

export default vacancyStore;
